const translations = {
  en: {
    dashboards: "Dashboards",
    simulator: "Chart generator",
    reports: "Reports",
    forms: "Forms",
    userManagement: "User Management",
    admin: "Admin",
    newReport: "New Report",
    downloadReport: "Download Report",
    userRoles: "User Roles",
    addUser: "Add User",
    report: "Report",
    search: "Search",
    newForm: "New Form",
    searchForForm: "Search for a form",
    items: "items",
    untitled: "Untitled",
    taf: "Teacher Assessment Form",
    caf: "Class Assessment Form",
    paf: "Pupil Assessment Form",
    form: "Form",
    schoolName: "School Name",
    grade: "Grade",
    division: "Division",
    noofStudents: "No of Students",
    dateofAssessment: "Date of Assessment",
    numeracy: "Numeracy",
    numeracyDesc:
      "Record the number of students who were able to successfully complete the following tasks.",
    singleDigitAddition: "Single Digit Addition",
    doubleDigitAddition: "Double Digit Addition",
    multiplication: "Multiplication",
    averages: "Averages",
    averageNumercayScore: "Average Numercay Score",
    records: "Records",
    typeHere: "Type here",
    selectFromDD: "Select from the dropdown",
    one: "One",
    two: "Two",
    three: "Three",
    editForm: "Edit form",
    upload: "Upload",
    allRecords: "All Records",
    submit: "Submit",
    recentUploads: "Recent uploads",
    browseForFile: "Browse for the file",
    uploadFile: "Upload file",
    all: "All",
    sortAZ: "A-Z",
    sortZA: "Z-A",
    formName: "Form name",
    uploadedBy: "Uploaded by",
    submittedOn: "Submitted on",
    saveForm: "Save Form",
    formTitle: "Form Title",
    deleteForm: "Delete form",
    newField: "New field",
    addSeparator: "Add separator",
    addSectionHan: "Add section handling"
  },
  se: {
    dashboards: "Instrumentpaneler",
    simulator: "Chart generator",
    reports: "Rapporter",
    forms: "Formulär",
    userManagement: "Användarhantering",
    newReport: "Ny rapport",
    downloadReport: "Ladda ner rapport",
    userRoles: "Användarroller",
    addUser: "Lägg till användare",
    report: "Rapportera",
    search: "Sök",
    admin: "Administration",
    newForm: "Ny form",
    searchForForm: "Sök efter ett formulär",
    items: "objekt",
    untitled: "Ofrälse",
    taf: "Formulär för bedömning av lärare",
    caf: "Klassbedömningsformulär",
    paf: "Elevbedömningsformulär",
    form: "Form",
    schoolName: "Skolnamn",
    grade: "Kvalitet",
    division: "Division",
    noofStudents: "Antal studenter",
    dateofAssessment: "Bedömningsdatum",
    numeracy: "Räknefärdighet",
    numeracyDesc:
      "Spela in antalet elever som lyckades klara följande uppgifter.",
    singleDigitAddition: "Enstaka siffretillägg",
    doubleDigitAddition: "Tvåsiffrig tillägg",
    multiplication: "Multiplikation",
    averages: "Genomsnitt",
    averageNumercayScore: "Genomsnittligt antal poäng",
    records: "Uppgifter",
    typeHere: "Skriv här",
    selectFromDD: "Välj från rullgardinsmenyn",
    one: "Ett",
    two: "Två",
    three: "Tre",
    editForm: "Redigera formulär",
    upload: "Ladda upp",
    allRecords: "Alla poster",
    submit: "Skicka in",
    recentUploads: "Senaste uppladdningar",
    browseForFile: "Bläddra efter filen",
    uploadFile: "Ladda upp fil",
    all: "Allt",
    sort: "Sortera",
    formName: "Formnamn",
    uploadedBy: "Uppladdad av",
    submittedOn: "Inlämnad den",
    saveForm: "Spara formulär",
    formTitle: "Formtitel",
    deleteForm: "Radera formulär",
    newField: "Nytt fält",
    addSeparator: "Lägg till separator",
    addSectionHan: "Lägg till sektionhantering"
  },
  gu: {
    dashboards: "ડેશબોર્ડ્સ",
    simulator: "Chart generator",
    reports: "અહેવાલો",
    userManagement: "વપરાશકર્તા વ્યવસ્થાપન",
    newReport: "નવો અહેવાલ",
    downloadReport: "રિપોર્ટ ડાઉનલોડ કરો",
    userRoles: "વપરાશકર્તા ભૂમિકા",
    addUser: "વપરાશકર્તા ઉમેરો",
    report: "અહેવાલ",
    search: "શોધો",
    admin: "એડમિન",
    newForm: "નવું ફોર્મ",
    searchForForm: "ફોર્મ માટે શોધ કરો",
    items: "આઇટમ્સ",
    untitled: "શીર્ષક વિનાનું",
    taf: "શિક્ષક મૂલ્યાંકન ફોર્મ",
    caf: "વર્ગ આકારણી ફોર્મ",
    paf: "વિદ્યાર્થી આકારણી ફોર્મ",
    forms: "ફોર્મ",
    schoolName: "શાળા નામ",
    grade: "ગ્રેડ",
    division: "વિભાગ",
    noofStudents: "વિદ્યાર્થીઓની સંખ્યા",
    dateofAssessment: "આકારણીની તારીખ",
    numeracy: "આંકડા",
    numeracyDesc:
      "નીચેના કાર્યોને સફળતાપૂર્વક પૂર્ણ કરવામાં સક્ષમ એવા વિદ્યાર્થીઓની સંખ્યા રેકોર્ડ કરો.",
    singleDigitAddition: "સિંગલ ડિજિટ એડિશન",
    doubleDigitAddition: "ડબલ ડિજિટ એડિશન",
    multiplication: "ગુણાકાર",
    averages: "સરેરાશ",
    averageNumercayScore: "સરેરાશ ન્યુમર્સે સ્કોર",
    records: "રેકોર્ડ્સ",
    typeHere: "અહી લખો",
    selectFromDD: "નીચે આવતામાંથી પસંદ કરો",
    one: "એક",
    two: "બે",
    three: "ત્રણ",
    editForm: "ફોર્મ સંપાદિત કરો",
    upload: "અપલોડ કરો",
    allRecords: "બધા રેકોર્ડ્સ",
    submit: "સબમિટ કરો",
    recentUploads: "તાજેતરનાં અપલોડ્સ",
    browseForFile: "ફાઇલ માટે બ્રાઉઝ કરો",
    uploadFile: "ફાઈલ અપલોડ કરો",
    all: "બધા",
    sort: "સortર્ટ કરો",
    formName: "ફોર્મ નામ",
    uploadedBy: "દ્વારા અપલોડ કરેલ",
    submittedOn: "સબમિટ ઓન",
    saveForm: "ફોર્મ સાચવો",
    formTitle: "ફોર્મ શીર્ષક",
    deleteForm: "ફોર્મ કા Deleteી નાખો",
    newField: "નવું ક્ષેત્ર",
    addSeparator: "વિભાજક ઉમેરો",
    addSectionHan: "વિભાગ હેન્ડલિંગ ઉમેરો"
  },
  ta: {
    dashboards: "டாஷ்போர்டுகள்",
    simulator: "Chart generator",
    reports: "அறிக்கைகள்",
    forms: "வடிவங்கள்",
    userManagement: "பயனர் மேலாண்மை",
    newReport: "புதிய அறிக்கை",
    downloadReport: "பதிவிறக்க அறிக்கை",
    userRoles: "பயனர் பாத்திரங்கள்",
    addUser: "பயனரைச் சேர்க்கவும்",
    report: "அறிக்கை",
    search: "தேடல்",
    admin: "நிர்வாகம்",
    newForm: "புதிய படிவம்",
    searchForForm: "ஒரு படிவத்தைத் தேடு",
    items: "பொருட்களை",
    untitled: "பெயரிடப்படாதது",
    taf: "ஆசிரியர் மதிப்பீட்டு படிவம்",
    caf: "வகுப்பு மதிப்பீட்டு படிவம்",
    paf: "மாணவர் மதிப்பீட்டு படிவம்",
    form: "படிவம்",
    schoolName: "பள்ளி பெயர்",
    grade: "தரம்",
    division: "பிரிவு",
    noofStudents: "மாணவர்களின் எண்ணிக்கை",
    dateofAssessment: "மதிப்பீட்டு தேதி",
    numeracy: "எண்ணறிவு",
    numeracyDesc:
      "பின்வரும் பணிகளை வெற்றிகரமாக முடிக்க முடிந்த மாணவர்களின் எண்ணிக்கையை பதிவு செய்யுங்கள்.",
    singleDigitAddition: "ஒற்றை இலக்க சேர்த்தல்",
    doubleDigitAddition: "இரட்டை இலக்க சேர்த்தல்",
    multiplication: "பெருக்கல்",
    averages: "சராசரி",
    averageNumercayScore: "சராசரி எண் ஸ்கோர்",
    records: "ரெக்கார்ட்ஸ்",
    typeHere: "இங்கே தட்டச்சு செய்க",
    selectFromDD: "கீழ்தோன்றலில் இருந்து தேர்ந்தெடுக்கவும்",
    one: "ஒன்று",
    two: "இரண்டு",
    three: "மூன்று",
    editForm: "படிவத்தைத் திருத்து",
    upload: "பதிவேற்றம்",
    allRecords: "அனைத்து பதிவுகளும்",
    submit: "சமர்ப்பி",
    recentUploads: "சமீபத்திய பதிவேற்றங்கள்",
    browseForFile: "கோப்பை உலாவுக",
    uploadFile: "கோப்பைப் பதிவேற்று",
    all: "எல்லாம்",
    sort: "வகைபடுத்து",
    formName: "படிவத்தின் பெயர்",
    uploadedBy: "பதிவேற்றியது",
    submittedOn: "சமர்ப்பிக்கப்பட்டது",
    saveForm: "படிவத்தை சேமி",
    formTitle: "படிவ தலைப்பு",
    deleteForm: "படிவத்தை நீக்கு",
    newField: "புதிய புலம்",
    addSeparator: "பிரிப்பானைச் சேர்",
    addSectionHan: "பிரிவு கையாளுதலைச் சேர்"
  },
  ml: {
    dashboards: "ഡാഷ്‌ബോർഡുകൾ",
    simulator: "Chart generator",
    reports: "റിപ്പോർട്ടുകൾ",
    forms: "ഫോമുകൾ",
    userManagement: "ഉപയോക്തൃ മാനേജുമെന്റ്",
    newReport: "പുതിയ റിപ്പോർട്ട്",
    downloadReport: "റിപ്പോർട്ട് ഡൗൺലോഡുചെയ്യുക",
    userRoles: "ഉപയോക്തൃ റോളുകൾ",
    addUser: "ഉപയോക്താവിനെ ചേർക്കുക",
    report: "റിപ്പോർട്ട് ചെയ്യുക",
    search: "തിരയൽ",
    admin: "അഡ്മിൻ",
    newForm: "പുതിയ ഫോം",
    searchForForm: "ഒരു ഫോമിനായി തിരയുക",
    items: "ഇനങ്ങൾ",
    untitled: "ശീർഷകമില്ലാത്തത്",
    taf: "ടീച്ചർ അസസ്മെന്റ് ഫോം",
    caf: "ക്ലാസ് അസസ്മെന്റ് ഫോം",
    paf: "വിദ്യാർത്ഥി വിലയിരുത്തൽ ഫോം",
    form: "ഫോം",
    schoolName: "വിദ്യാലയത്തിന്റെ നാമം",
    grade: "ഗ്രേഡ്",
    division: "ഡിവിഷൻ",
    noofStudents: "വിദ്യാർത്ഥികളുടെ എണ്ണം",
    dateofAssessment: "വിലയിരുത്തൽ തീയതി",
    numeracy: "സംഖ്യ",
    numeracyDesc:
      "ഇനിപ്പറയുന്ന ജോലികൾ വിജയകരമായി പൂർത്തിയാക്കാൻ കഴിഞ്ഞ വിദ്യാർത്ഥികളുടെ എണ്ണം രേഖപ്പെടുത്തുക.",
    singleDigitAddition: "ഒറ്റ അക്ക കൂട്ടിച്ചേർക്കൽ",
    doubleDigitAddition: "ഇരട്ട അക്ക കൂട്ടിച്ചേർക്കൽ",
    multiplication: "ഗുണനം",
    averages: "ശരാശരി",
    averageNumercayScore: "ശരാശരി സംഖ്യ സ്‌കോർ",
    records: "രേഖകള്",
    typeHere: "ഇവിടെ ടൈപ്പ് ചെയ്യു",
    selectFromDD: "ഡ്രോപ്പ്ഡ down ണിൽ നിന്ന് തിരഞ്ഞെടുക്കുക",
    one: "ഒന്ന്",
    two: "രണ്ട്",
    three: "മൂന്ന്",
    editForm: "ഫോം എഡിറ്റുചെയ്യുക",
    upload: "അപ്‌ലോഡുചെയ്യുക",
    allRecords: "എല്ലാ റെക്കോർഡുകളും",
    submit: "സമർപ്പിക്കുക",
    recentUploads: "സമീപകാല അപ്‌ലോഡുകൾ",
    browseForFile: "ഫയലിനായി ബ്ര rowse സ് ചെയ്യുക",
    uploadFile: "ഫയൽ അപ്‌ലോഡ് ചെയ്യുക",
    all: "എല്ലാം",
    sort: "അടുക്കുക",
    formName: "ഫോമിന്റെ പേര്",
    uploadedBy: "അപ്‌ലോഡുചെയ്‌തത്",
    submittedOn: "സമർപ്പിച്ചു",
    saveForm: "ഫോം സംരക്ഷിക്കുക",
    formTitle: "ഫോം ശീർഷകം",
    deleteForm: "ഫോം ഇല്ലാതാക്കുക",
    newField: "പുതിയ ഫീൽഡ്",
    addSeparator: "സെപ്പറേറ്റർ ചേർക്കുക",
    addSectionHan: "വിഭാഗം കൈകാര്യം ചെയ്യൽ ചേർക്കുക"
  },
  kn: {
    dashboards: "ಡ್ಯಾಶ್‌ಬೋರ್ಡ್‌ಗಳು",
    simulator: "Chart generator",
    reports: "ವರದಿಗಳು",
    forms: "ಫಾರ್ಮ್‌ಗಳು",
    userManagement: "ಬಳಕೆದಾರ ನಿರ್ವಹಣೆറ്",
    newReport: "ಹೊಸ ವರದಿ",
    downloadReport: "ವರದಿ ಡೌನ್‌ಲೋಡ್ ಮಾಡಿ",
    userRoles: "ಬಳಕೆದಾರರ ಪಾತ್ರಗಳು",
    addUser: "ಬಳಕೆದಾರರನ್ನು ಸೇರಿಸಿ",
    report: "ವರದಿ",
    search: "ಹುಡುಕಾಟ",
    admin: "ನಿರ್ವಾಹಕ",
    newForm: "ಹೊಸ ಫಾರ್ಮ್",
    searchForForm: "ಫಾರ್ಮ್ಗಾಗಿ ಹುಡುಕಿ",
    items: "ಐಟಂಗಳು",
    untitled: "ಶೀರ್ಷಿಕೆರಹಿತ",
    taf: "ಶಿಕ್ಷಕರ ಮೌಲ್ಯಮಾಪನ ಫಾರ್ಮ್",
    caf: "ವರ್ಗ ಮೌಲ್ಯಮಾಪನ ಫಾರ್ಮ್",
    paf: "ವಿದ್ಯಾರ್ಥಿ ಮೌಲ್ಯಮಾಪನ ಫಾರ್ಮ್",
    form: "ಫಾರ್ಮ್",
    schoolName: "ಶಾಲೆಯ ಹೆಸರು",
    grade: "ಗ್ರೇಡ್",
    division: "ವಿಭಾಗ",
    noofStudents: "ವಿದ್ಯಾರ್ಥಿಗಳ ಸಂಖ್ಯೆ",
    dateofAssessment: "ಮೌಲ್ಯಮಾಪನ ದಿನಾಂಕ",
    numeracy: "ಸಂಖ್ಯಾಶಾಸ್ತ್ರ",
    numeracyDesc:
      "ಈ ಕೆಳಗಿನ ಕಾರ್ಯಗಳನ್ನು ಯಶಸ್ವಿಯಾಗಿ ಪೂರ್ಣಗೊಳಿಸಲು ಸಾಧ್ಯವಾದ ವಿದ್ಯಾರ್ಥಿಗಳ ಸಂಖ್ಯೆಯನ್ನು ರೆಕಾರ್ಡ್ ಮಾಡಿ.",
    singleDigitAddition: "ಏಕ ಅಂಕೆ ಸೇರ್ಪಡೆ",
    doubleDigitAddition: "ಡಬಲ್ ಅಂಕೆ ಸೇರ್ಪಡೆ",
    multiplication: "ಗುಣಾಕಾರ",
    averages: "ಸರಾಸರಿ",
    averageNumercayScore: "ಸರಾಸರಿ ಸಂಖ್ಯಾ ಸ್ಕೋರ್",
    records: "ದಾಖಲೆಗಳು",
    typeHere: "ಇಲ್ಲಿ ಬರೆಯಿರಿ",
    selectFromDD: "ಡ್ರಾಪ್‌ಡೌನ್‌ನಿಂದ ಆಯ್ಕೆಮಾಡಿ",
    one: "ಒಂದು",
    two: "ಎರಡು",
    three: "ಮೂರು",
    editForm: "ಫಾರ್ಮ್ ಸಂಪಾದಿಸಿ",
    upload: "ಅಪ್‌ಲೋಡ್",
    allRecords: "ಆಲ್ ರೆಕಾರ್ಡ್ಸ್",
    submit: "ಸಲ್ಲಿಸು",
    recentUploads: "ಇತ್ತೀಚಿನ ಅಪ್‌ಲೋಡ್‌ಗಳು",
    browseForFile: "ಫೈಲ್‌ಗಾಗಿ ಬ್ರೌಸ್ ಮಾಡಿ",
    uploadFile: "ಫೈಲ್ ಅಪ್‌ಲೋಡ್",
    all: "ಎಲ್ಲಾ",
    sort: "ವಿಂಗಡಿಸು",
    formName: "ಫಾರ್ಮ್ ಹೆಸರು",
    uploadedBy: "ಅಪ್‌ಲೋಡ್ ಮಾಡಲಾಗಿದೆ",
    submittedOn: "ಸಲ್ಲಿಸಲಾಗಿದೆ",
    saveForm: "ಫಾರ್ಮ್ ಉಳಿಸಿ",
    formTitle: "ಫಾರ್ಮ್ ಶೀರ್ಷಿಕೆ",
    deleteForm: "ಫಾರ್ಮ್ ಅಳಿಸು",
    newField: "ಹೊಸ ಕ್ಷೇತ್ರ",
    addSeparator: "ವಿಭಜಕವನ್ನು ಸೇರಿಸಿ",
    addSectionHan: "ವಿಭಾಗ ನಿರ್ವಹಣೆಯನ್ನು ಸೇರಿಸಿ"
  },
  hi: {
    dashboards: "डैशबोर्ड",
    simulator: "Chart generator",
    reports: "रिपोर्ट",
    forms: "फार्म",
    userManagement: "उपयोगकर्ता प्रबंधन",
    newReport: "नया रिपोर्ट",
    downloadReport: "रिपोर्ट डाउनलोड करें",
    userRoles: "उपयोगकर्ता भूमिका",
    addUser: "उपयोगकर्ता जोड़ें",
    report: "रिपोर्ट",
    search: "खोज",
    admin: "व्यवस्थापक",
    newForm: "नए रूप मे",
    searchForForm: "एक फ़ॉर्म खोजें",
    items: "आइटम",
    untitled: "शीर्षकहीन",
    taf: "शिक्षक मूल्यांकन प्रपत्र",
    caf: "क्लास असेसमेंट फॉर्म",
    paf: "पुपिल असेसमेंट फॉर्म",
    form: "प्रपत्र",
    schoolName: "विद्यालय का नाम",
    grade: "ग्रेड",
    division: "विभाजन",
    noofStudents: "विद्यार्थियों की संख्या",
    dateofAssessment: "मूल्यांकन की तिथि",
    numeracy: "संख्यात्मक कार्यो",
    numeracyDesc:
      "उन छात्रों की संख्या रिकॉर्ड करें जो निम्नलिखित कार्यों को सफलतापूर्वक पूरा करने में सक्षम थे।",
    singleDigitAddition: "सिंगल डिजिट एडिशन",
    doubleDigitAddition: "डबल डिजिट एडिशन",
    multiplication: "गुणा",
    averages: "औसत",
    averageNumercayScore: "औसत न्यूमेरके स्कोर",
    records: "रिकॉर्ड्स",
    typeHere: "यहा लिखो",
    selectFromDD: "ड्रॉपडाउन से चुनें",
    one: "एक",
    two: "दो",
    three: "तीन",
    editForm: "फ़ॉर्म संपादित करें",
    upload: "डालना",
    allRecords: "सभी रिकॉर्ड्स",
    submit: "प्रस्तुत",
    recentUploads: "हाल के अपलोड",
    browseForFile: "फ़ाइल के लिए ब्राउज़ करें",
    uploadFile: "दस्तावेज अपलोड करें",
    all: "सब",
    sort: "क्रमबद्ध करें",
    formName: "फ़ार्म का नाम",
    uploadedBy: "द्वारा डाली गई",
    submittedOn: "पर प्रस्तुत की",
    saveForm: "सेव फॉर्म",
    formTitle: "फॉर्म देखें",
    deleteForm: "फ़ॉर्म हटाएं",
    newField: "नया क्षेत्र",
    addSeparator: "विभाजक जोड़ें",
    addSectionHan: "अनुभाग हैंडलिंग जोड़ें"
  }
};

export { translations };
